import { ReactNode, useState } from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
    Label,
    Button,
} from 'reactstrap'
import classNames from 'classnames'

import Loader from '../../../components/shared/loader'
import Modal from '../../../components/shared/modal'
import EditValue from './edit-value'

import type { DeviceEntity } from './parse-device-data'

interface DeviceDataSetting {
    address: string
    hint?: string
    data: string | number
    type?: string
}

interface Props {
    title: ReactNode
    data: ReactNode
    measurement?: ReactNode
    device: DeviceEntity
    dataSetting?: DeviceDataSetting
    className?: string
    children?: ReactNode
}

interface RootState {
    devices: {
        deviceWriter: Array<number | string>
    }
}

const DevicePumpSettingsInput = ({
    title,
    data,
    measurement,
    device,
    dataSetting: deviceData,
    className,
    children,
}: Props) => {
    const deviceWriter = useSelector((state: RootState) => state.devices.deviceWriter)
    const [editDataModal, setEditDataModal] = useState<{ device: DeviceEntity, deviceData: DeviceDataSetting } | null>(null)
    const { t } = useTranslation()

    return (
        <>
            <div className={classNames({
                'd-flex flex-column w-100 mb-4': true,
                [className ?? '']: !!className,
            })}
            >
                <Label>
                    {title} {children}
                </Label>
                <Button
                    color='falcon-default'
                    onClick={() => {
                        if (deviceData) {
                            setEditDataModal({ device, deviceData })
                        }
                    }}
                >
                    {deviceData?.address !== undefined && deviceWriter.includes(deviceData.address) ? (
                        <Loader className='ml-2' height={18} />
                    ) : (
                        <div className='d-flex justify-content-between'>
                            <span>{data}</span>
                            <span>{measurement}</span>
                        </div>
                    )}
                </Button>
            </div>
            {editDataModal && (
                <Modal
                    description={t('deviceDetail.edit')}
                    handleHideModal={() =>
                        setEditDataModal(null)
                    }
                    content={() => (
                        <EditValue
                            editDataModal={editDataModal}
                            onSuccess={() =>
                                setEditDataModal(null)
                            }
                        />
                    )}
                />
            )}
        </>
    )
}

export default DevicePumpSettingsInput
